import PropTypes from 'prop-types';

import Text from '@zenbusiness/zui/Text';

import * as Styled from './TooltipTitle.style';

function TooltipTitle({ text }) {
  return (
    <Styled.TooltipTitle>
      <Text gutterBottom size="md">
        Why am I seeing this?
      </Text>

      <Text align="left" size="sm" weight="regular">
        {text}
      </Text>
    </Styled.TooltipTitle>
  );
}

TooltipTitle.propTypes = {
  text: PropTypes.string,
};

export default TooltipTitle;
